
/**
 *  Tool :: Form :: php-serialize using JS.
 */
import './form/php-serialize.js';

/**
 * Our nifty loader that will use our logo; like Gmail does it.
 */
import './widget/loader.js';

/**
 *  The boxes on the capabilities page.
 */
import './widget/boxes.js';

// TODO: fix the damn slider, it's embarrassing


// WEBPACK FOOTER //
// ./build/vendor/tbo/js/app.js